module.exports = __webpack_public_path__ + "img/26.4392e934.jpeg";